// Navigation menu items with their corresponding URLs and display names
const menuItems = [
    {
        url: '/',
        display: 'Home'
    },
    {
        url: '/#about',
        display: 'About'
    },
    {
        url: '/#services',
        display: 'Service'
    },
    {
        url: '/#portfolio',
        display: 'Portfolio'
    },
    {
        url: '/#contact',
        display: 'Contact'
    },
]

export default menuItems;